import utils from 'utils'
import globalFnFactory from 'components/globalFn/globalFnFactory'
import stockService from 'common/services/stockService'

const globalFn = globalFnFactory()

function lengthForString(temp) {
    let len = 0
    temp = $.trim(temp)
    for (let i = 0; i < temp.length; i += 1) {
        const c = temp.charCodeAt(i)
        // 单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
            len += 1
        } else {
            len += 2
        }
    }
    return len
}

function realTaxCalculation(amt, taxrate, taxFlag) {
    let taxamount = 0
    if (taxFlag === '1') { // 含税
        taxamount = globalFn.Div(globalFn.Mul(amt, taxrate), globalFn.Add(1, taxrate))
        if (taxrate == '0.015') {
            taxamount = parseFloat(amt / 1.05 * 0.015).toFixed(2)
        }
    } else { // 不含税
        taxamount = globalFn.Mul(amt, taxrate)
        if (taxrate == '0.015') {
            taxamount = parseFloat(amt * 0.015 / 1.035).toFixed(2)
        }
    }
    return taxamount
}

// 是否正确的金额
function isAmount(v, isRed) {
    let reg = /^\d{1,11}(\.\d{0,2})?$/ // 金额规则 数字，小数点前12位，后2位
    if (isRed) {
        reg = /^-\d{1,11}(\.\d{0,2})?$/
    }
    return parseFloat(v) !== 0 && reg.test(v)
}

// 精确n位小数
function toFixed(v, n) {
    return parseFloat(v).toFixed(n)
}

// 校验是否超过限额
function checkQuota(amt, quota) {
    return globalFn.Sub(amt, quota) > 0
}

// 是否差额
function hasBalanced(invoice) {
    const {
        waitDetailList,
    } = invoice
    return (waitDetailList.length === 1 || waitDetailList.length === 2) && waitDetailList[0].balance
}

// 校验单条明细-0.01<=(数量*单价-金额 )<= 0.01
function checkjewc(price, num, amount) {
    const amount1 = toFixed(globalFn.Mul(price, num), 2)
    return globalFn.Sub(Math.abs(globalFn.Sub(amount1, amount)), 0.01) > 0
}


const diskInfoChecker = {
    openCheck(invoice = {}, diskInfo) {
        // let invoice = inv[0]
        // saas电子票也走这个流程
        // if (invoice.invType === '51') {
        //     return ''
        // }
        if (!diskInfo.taxCode) {
            return '没有检测到开票硬件介质，请确认连接后，刷新页面后重试'
        }
        if (invoice.saleCreditCode !== diskInfo.taxCode) {
            return '当前插入设备税号与待开发票销方税号不一致,请重新选择！'
        }
        if (diskInfo.invMcType === 0 && invoice.diskCode !== diskInfo.kpfwqh) {
            return '您选择的发票开票点与插入的硬件介质不一致,请重新选择！'
        }
        if (diskInfo.invMcType === 1 && (invoice.ukeyCode !== diskInfo.machineNo ||
                invoice.diskCode !== diskInfo.kpfwqh)) {
            return '您选择的发票开票点与插入的硬件介质不一致,请重新选择！'
        }
        return ''
    },
    /**
     * 批量开票检测开票点
     * @param  {array}  invoiceList [发票数组不校验长度]
     * @param  {object} diskInfo    [硬件信息]
     * @return {string}             [错误提示]
     */
    batchOpenCheck(invoiceList, diskInfo) {
        const firstInvoice = invoiceList[0]
        let hasDifferentUkey = false
        for (let i = 0; i < invoiceList.length; i += 1) {
            if (invoiceList[i].ukeyId !== firstInvoice.ukeyId) {
                hasDifferentUkey = true
            }
        }
        if (hasDifferentUkey) {
            return '您选择的发票中有多个开票点，请筛选同一开票点的发票进行开票！'
        }
        const error = this.openCheck(firstInvoice, diskInfo)
        if (error) {
            return error
        }
        return ''
    },
}

/**
 * [checkWithDiskInfo description]
 * @param  {[type]} invoiceOrList [description]
 * @param  {String} method        [description]
 * @return {[type]}               [description]
 */
export function checkWithDiskInfo(invoiceOrList, method = 'batchOpenCheck') {
    const invType = invoiceOrList.length ? invoiceOrList[0].invType || invoiceOrList[0].invoiceType || 0 : 0
    return new Promise((resolve, reject) => {
        stockService.getDiskInfo().then(disk => {
            $.post({
                url: `${window.location.origin}/etcloud/etcloud-sys/common/common/getJSONObject`,
                dataType: 'json',
                data: JSON.stringify({
                    data: disk
                }),
                contentType: 'application/json; charset=utf-8',
                success(res) {
                    const SIDParam = res.value
                    if (SIDParam.retcode != 0) {
                        reject(SIDParam.retmsg)
                    } else {
                        const diskInfo = {
                            taxCode: SIDParam.TaxCode,
                            machineNo: SIDParam.MachineNo,
                            kpfwqh: SIDParam.kpfwqh,
                            CheckCode: SIDParam.CheckCode,
                            invMcType: SIDParam.InvMcType,
                        }
                        const error = invoiceOrList[0] && diskInfoChecker.batchOpenCheck(invoiceOrList, diskInfo)
                        if (error) {
                            reject(error)
                        } else {
                            invoiceOrList[0] && invoiceOrList.forEach((invoice) => {
                                invoice.hardwareNo = diskInfo.CheckCode
                            })
                            resolve(diskInfo)
                        }
                    }
                }
            })
        }, err => {
            reject(err)
        })
        // window.top.TaxCore.tax.invInfo(invType, (data) => {
        //     if (data != null) {
        //         if (!data.value) {
        //             // logger.logError(data.retmsg);
        //             return
        //         }
        //         const SIDParam = $.parseJSON(data.value)
        //         if (SIDParam.retcode != 3011) {
        //             reject(SIDParam.retmsg)
        //         } else {
        //             const diskInfo = {
        //                 taxCode: SIDParam.TaxCode,
        //                 machineNo: SIDParam.MachineNo,
        //                 kpfwqh: SIDParam.Kpfwqh,
        //                 CheckCode: SIDParam.CheckCode,
        //                 invMcType: SIDParam.InvMcType,
        //             }
        //             const error = invoiceOrList[0] && diskInfoChecker.batchOpenCheck(invoiceOrList, diskInfo)
        //             if (error) {
        //                 reject(error)
        //             } else {
        //                 invoiceOrList[0] && invoiceOrList.forEach((invoice) => {
        //                     invoice.hardwareNo = diskInfo.CheckCode
        //                 })
        //                 resolve(diskInfo)
        //             }
        //         }
        //     } else {
        //         reject('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
        //     }
        // }, '', '', 0)
    })
}
/**
 * 明细行校验
 * @param  {[Invoice]}  invoice     发票对象
 * @param  {[number]}  limitNumber  明细行限制
 * @param  {Boolean} isTax          是否含税
 * @param  {[number]}  quota        限额
 * @return {[string]}               错误提示
 */
export function detailCheck(invoice) {
    const {
        isTax,
        limitNumber,
        quota,
    } = invoice
    const detailList = invoice.waitDetailList
    console.log(detailList)
    const bll = detailList.length
    const refinedOils = detailList.filter((item) => {
        return utils.isRefinedOil(item.revenueCode)
    })
    const unRefinedOils = detailList.filter((item) => {
        return !!item.revenueCode && !utils.isRefinedOil(item.revenueCode)
    })
    const refinedOilLength = refinedOils.length
    const unRefinedOilLength = unRefinedOils.length
    const isRefinedOil = refinedOilLength > 0
    if (isRefinedOil && (unRefinedOilLength > 0)) {
        return '一张发票不能同时开具成品油与其他商品'
    }
    if (isRefinedOil && (invoice.isList === '1')) {
        return '成品油不能开具清单发票'
    }
    let maxGoods = limitNumber
    if (isRefinedOil && (invoice.invType !== '41')) {
        maxGoods = 8
    }
    if (maxGoods && (bll > maxGoods)) {
        return `商品行数最多不能超过${maxGoods}行！`
    }
    let sewc = 0 // 税额误差
    let sumSewc = 0 // 金额总误差
    for (let i = 0; i < bll; i += 1) {
        if (detailList[i].lineNature === '1') {
            continue
        }
        const billLine = detailList[i]
        const spNumVal = `第${i + 1}行`

        if (lengthForString(billLine.matName) === 0) {
            return `${spNumVal}商品名称不能为空`
        }
        if (lengthForString(billLine.matName) > 92) {
            return `${spNumVal}商品名称长度不能超过92个字节，一个汉字算2个字节`
        }
        if (lengthForString(billLine.spec) > 40) {
            return `${spNumVal}商品规格型号不能超过40个字节，一个汉字算2个字节`
        }
        if (lengthForString(billLine.unit) > 22) {
            return `${spNumVal}商品计量单位不能超过22个字节，一个汉字算2个字节`
        }
        if (isRefinedOil && (invoice.invType !== '41') && (billLine.unit !== '吨') && (billLine.unit !== '升')) {
            return `${spNumVal}成品油商品，计量单位必为“吨”或“升”`
        }
        if (isRefinedOil && (!billLine.quantity || (billLine.quantity * 1 === 0))) {
            return `${spNumVal}成品油商品，数量不能为空或0`
        }
        if (lengthForString(billLine.amount) === 0 || Math.abs(billLine.amount) === 0) {
            return `${spNumVal}商品金额不能为空或0`
        }
        if (lengthForString(billLine.taxRate) === 0) {
            return `${spNumVal}商品税率不能为空`
        }
        if (billLine.isTax === '1' && !billLine.taxPrice && billLine.quantity) {
            return `${spNumVal}商品数量不为空，则商品单价不能为空`
        }
        if (billLine.isTax === '1' && billLine.taxPrice && !billLine.quantity) {
            return `${spNumVal}商品单价不为空，则商品数量不能为空`
        }
        if (billLine.isTax !== '1' && !billLine.price && billLine.quantity) {
            return `${spNumVal}商品数量不为空，则商品单价不能为空`
        }
        if (billLine.isTax !== '1' && billLine.price && !billLine.quantity) {
            return `${spNumVal}商品单价不为空，则商品数量不能为空`
        }
        if (!isAmount(billLine.amount, billLine.isRed) || !isAmount(billLine.adValoremTotal, billLine.isRed)) {
            return `${spNumVal}商品金额格式不正确`
        }
        if (billLine.taxRate == 0.015 && billLine.balance != 0 && billLine.balance != null) {
            return `${spNumVal}1.5%税率不能填差额征税`
        }
        if (billLine.taxRate == 0 && invoice.invType == '0') {
            return `${spNumVal}专票填开不能录入税率为0的商品`
        }
        if (billLine.taxRate == 0.015 && invoice.invType == '51') {
            return `${spNumVal}电子发票不能录入税率为1.5%的商品`
        }
        if (lengthForString(billLine.price) > 0 && lengthForString(billLine.quantity) > 0 && checkjewc(billLine.price, billLine.quantity, billLine.amount)) {
            return `${spNumVal}单价数量金额误差大于0.01`
        }
        if (billLine.isTax !== '1' && billLine.price === 0 && invoice.invType == '51') {
            return `${spNumVal}电子发票单价不能为0`
        }
        if (billLine.isTax === '1' && billLine.taxPrice === 0 && invoice.invType == '51') {
            return `${spNumVal}电子发票单价不能为0`
        }
        let balance = 0
        if (lengthForString(billLine.balance) > 0) {
            balance = parseFloat(billLine.balance)
        }
        let realSewc
        if (isTax === '1') {
            realSewc = realTaxCalculation(globalFn.Sub(billLine.adValoremTotal, balance), billLine.taxRate, isTax)
        } else {
            realSewc = realTaxCalculation(globalFn.Sub(billLine.amount, balance), billLine.taxRate, isTax)
        }
        sewc = Math.abs(globalFn.Sub(realSewc, billLine.taxAmount))
        if (globalFn.Sub(sewc, 0.06) > 0 && (billLine.taxRate != 10.02) && invoice.isRed != 1) {
            return `${spNumVal}发票金额乘以税率的值与税额的误差超过限制0.06`
        }
    }

    // 是否1.5%税率且多税率
    // 是否多税率
    let mulRate0015 = false
    const newRateArr = invoice.waitDetailList.map((item) => item.taxRate)
    if (newRateArr.length > 1 && newRateArr.indexOf(0.015) > -1) {
        for (let i = 0, l = newRateArr.length - 1; i < l; i++) {
            if (newRateArr[i] !== newRateArr[i + 1]) {
                mulRate0015 = true
                break
            }
        }
    }
    if (mulRate0015) {
        return '减按1.5计税发票不支持多税率发票开具'
    }

    if (quota && checkQuota(invoice.totalAmt, quota)) {
        return '当前商品行累计金额超过限额'
    }
    // 计算总误差
    for (let i = 0; i < bll; i += 1) {
        const billLine = detailList[i]
        if (billLine.taxRate == 10.02) return
        let balance = 0
        let realSewc
        if (lengthForString(billLine.balance) > 0) {
            balance = parseFloat(billLine.balance)
        }
        if (isTax === '1') {
            realSewc = realTaxCalculation(globalFn.Sub(billLine.adValoremTotal, balance), billLine.taxRate, isTax)
        } else {
            realSewc = realTaxCalculation(globalFn.Sub(billLine.amount, balance), billLine.taxRate, isTax)
        }
        sumSewc = globalFn.Add(sumSewc, realSewc)
    }


    // 是否超过误差
    sumSewc = toFixed(sumSewc, 2)
    const _sumSewc = Math.abs(globalFn.Sub(sumSewc, invoice.totalTaxamt))
    if (globalFn.Sub(_sumSewc, 1.27) > 0) {
        return '发票合计金额乘以税率的值与合计税额的误差超过限制1.27'
    }
    return ''
}

/**
 * 公共基础字段校验
 * @param  {[type]}  invoice     发票对象
 */
export function basicCheck(invoice) {
    // const userInfo = JSON.parse(localStorage.getItem('user_info'))
    // const {
    //     sale
    // } = userInfo
    // if ((!sale.platformPassword || !sale.authCode || !sale.platformCode) && invoice.invType == 51) {
    //     return '平台代码、平台密码、授权码不能为空！'
    // }
    if (!invoice.ukeyCode) {
        return '请选择开票点'
    }
    // if (!invoice.custCreditCode && invoice.creditType !== '3') {
    //     return '购方税号不能为空'
    // }
    // if (invoice.creditType !== '3' && !globalFn.checkTax(invoice.custCreditCode)) {
    //     return '购方税号格式不正确'
    // }
    if (!invoice.saleCreditCode) {
        return '销方税号不能为空'
    }
    if (!globalFn.checkTax(invoice.saleCreditCode)) {
        return '销方税号格式不正确'
    }
    if (!invoice.custName) {
        return '购方名称不能为空'
    }
    if (invoice.custName && lengthForString(invoice.custName) > 100) {
        return '购方名称长度不能超过100字节，一个汉字算2个字节'
    }
    if (lengthForString(invoice.custAddress + invoice.custPhone) > 100) {
        return '购方地址加电话长度不能超过100字节，一个汉字算2个字节'
    }
    if (lengthForString(invoice.custBankAccount + invoice.custBank) > 100) {
        return '购方银行加账号长度不能超过100字节，一个汉字算2个字节'
    }
    if (lengthForString(invoice.saleAddress + invoice.salePhone) > 100) {
        return '销方地址加电话长度不能超过100字节，一个汉字算2个字节'
    }
    if (lengthForString(invoice.saleBank + invoice.saleBankAccount) > 100) {
        return '销方银行加账号长度不能超过100字节，一个汉字算2个字节'
    }
    // 电子票校验
    if (invoice.invType === '51' && invoice.custEmail && !utils.regExpTestEmail(invoice.custEmail)) {
        return '邮箱地址格式不正确'
    }
    if (invoice.invType === '51' && invoice.custMobile && !utils.regExpTest(invoice.custMobile, 'mobile')) {
        return '手机号码格式不正确'
    }
    return ''
}
/**
 * 暂存时校验
 * @param  {[Invoice]}  invoice     发票对象
 * @param  {[number]}  limitNumber  明细行限制
 * @param  {Boolean} isTax          是否含税
 * @param  {[number]}  quota        限额
 * @return {[string]}               错误提示
 */
export function scratchCheck(invoice, limitNumber, quota) {
    const msg = basicCheck(invoice)
    if (msg) {
        return msg
    }
    if (invoice.waitDetailList.length === 0) {
        return ''
    }
    return detailCheck(invoice, limitNumber, quota)
}

/**
 * 红字普通发票备注及蓝票代码号码校验
 * @param  {Object} invoice    发票对象
 * @return {string}            错误提示
 */
export function redSubmitCheck(invoice) {
    // 购方为个人不需要校验购方税号
    if (invoice.invType === '0') {
        if (!invoice.custPhone && !invoice.custAddress) {
            return '开具专票，购方地址或电话号码不能为空'
        }
        if (!invoice.custBankAccount && !invoice.custBank) {
            return '开具专票，购方银行或账号不能为空'
        }
    }
    let invoiceCodeReg
    if (invoice.invType === '51' || invoice.invType === '41') {
        // 电子票
        invoiceCodeReg = /^[\d]{12}$/
    } else {
        // 纸质
        invoiceCodeReg = /^[\d]{10}$|^[\d]{12}$/
    }
    const invoiceNumReg = /^[\d]{8}$/
    if (invoice.redApplicant !== '1' && (!invoiceCodeReg.test(invoice.blueInvoiceCode) || !invoiceNumReg.test(invoice.blueInvoiceNumber))) {
        return '请备注正确的蓝票代码、号码'
    }
    if (hasBalanced(invoice) && invoice.remark.indexOf('差额征税。') === -1) {
        return '差额发票备注有误！'
    }
    let invoiceCodeLabel = '对应正数发票代码'
    let invoiceNumberLabel = '号码'
    if (invoice.redApplicant === '0' || invoice.redApplicant === '2') {
        invoiceCodeLabel = '对应蓝字专用发票代码'
        invoiceNumberLabel = '号码'
    }
    if (invoice.redApplicant !== '1' && (invoice.remark.indexOf(invoiceCodeLabel) === -1 ||
            invoice.remark.indexOf(invoiceNumberLabel) === -1 || invoice.blueInvoiceCode == null ||
            invoice.blueInvoiceCode === '' || invoice.blueInvoiceNumber == null || invoice.blueInvoiceNumber === '')) {
        return '备注内容格式不正确'
    }
    if (invoice.redApplicant !== '1' && (!invoice.blueInvoiceCode || !invoice.blueInvoiceNumber)) {
        return '未选择对应蓝票，或备注蓝票代码号码有误'
    }
    if (invoice.redAmount && globalFn.Sub(Math.abs(invoice.totalAmt), Math.abs(invoice.redAmount)) > 0) {
        return '红冲金额不能超过对应蓝票可红冲的金额！'
    }

    if (invoice.redTax && globalFn.Sub(Math.abs(invoice.totalTaxamt), Math.abs(invoice.redTax)) > 0) {
        return '红冲总税额不能超过对应蓝票可红冲的税额！'
    }
    return ''
}

/**
 * 提交/开票时检查
 * @return {[type]} [description]
 */
export function submitCheck(invoice) {
    const msg = basicCheck(invoice)
    if (msg) {
        return msg
    }
    const detailError = detailCheck(invoice)
    if (detailError) {
        return detailError
    }
    if (invoice.invType === '0') {
        if (!invoice.custPhone && !invoice.custAddress) {
            return '开具专票，购方地址或电话号码不能为空'
        }
        if (!invoice.custBankAccount && !invoice.custBank) {
            return '开具专票，购方银行或账号不能为空'
        }
    }
    if (invoice.isRed === '1') {
        return redSubmitCheck(invoice)
    }
    if (Math.abs(invoice.adValoremTotal) === 0 || Math.abs(invoice.totalAmt) === 0) {
        return '发票总金额不能为0'
    }
    if (!invoice.waitDetailList || invoice.waitDetailList.lenth === 0) {
        return '商品行不能为空！'
    }
    return ''
}

/**
 * 不校验购方基础字段
 * @param  {[type]}  invoice     发票对象
 */
export function scanSalerCheck(invoice) {
    if (!invoice.ukeyCode) {
        return '请选择开票点'
    }
    if (!invoice.saleCreditCode) {
        return '销方税号不能为空'
    }
    if (!globalFn.checkTax(invoice.saleCreditCode)) {
        return '销方税号格式不正确'
    }
    if (lengthForString(invoice.saleAddress + invoice.salePhone) > 100) {
        return '销方地址加电话长度不能超过100字节，一个汉字算2个字节'
    }
    if (lengthForString(invoice.saleBank + invoice.saleBankAccount) > 100) {
        return '销方银行加账号长度不能超过100字节，一个汉字算2个字节'
    }
    return ''
}
/**
 * 扫码开票不校验购方
 * @return {[type]} [description]
 */
export function scanSubmitCheck(invoice) {
    const msg = scanSalerCheck(invoice)
    if (msg) {
        return msg
    }
    const detailError = detailCheck(invoice)
    if (detailError) {
        return detailError
    }
    if (invoice.invType === '0') {
        if (!invoice.custPhone && !invoice.custAddress) {
            return '开具专票，购方地址或电话号码不能为空'
        }
        if (!invoice.custBankAccount && !invoice.custBank) {
            return '开具专票，购方银行或账号不能为空'
        }
    }
    if (invoice.isRed === '1') {
        return redSubmitCheck(invoice)
    }
    if (Math.abs(invoice.adValoremTotal) === 0 || Math.abs(invoice.totalAmt) === 0) {
        return '发票总金额不能为0'
    }
    if (!invoice.waitDetailList || invoice.waitDetailList.lenth === 0) {
        return '商品行不能为空！'
    }
    return ''
}


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/invoiceValidate.js